import { ParticipantLabelsState } from './types'

export const PARTICIPANT_LABELS_SLICE_NAME = 'participantLabels'
export const FETCH_CONVERSATION_PARTICIPANT_LABELS_ACTION_TYPE =
  `${PARTICIPANT_LABELS_SLICE_NAME}/fetchConversationParticipantLabels`

export const initialState: ParticipantLabelsState = {
  byParticipantId: {},
  loadedByConversationId: {},
  loadingByConversationId: {},
  failedByConversationId: {},
}